import React, { useRef } from "react";

/**
 * 
 * @function PageContainer 
 * @returns {React.Component}
 * @param { STRING } src - The url of the iframe.
 * @param { STRING } srcKey - The unique key of the node.
 * @exported true
 * @description An iframe component for showing ABI22 pages in MABI23 in full view, with no header or footer.
 * @example
    { fullPageIframe.show === true &&
        <ABI22PageIframeView srcKey={ src.key } src= { `${ origin }/#/${ fullPageIframe.abi22Route }` } />
    }
 */
export default function ABI22PageIframeView(props) {
    const src = props.src ?? "";
    const key = props.srcKey ?? "";
    const className = props.className ?? "";
    const ref = useRef();

    return (
        <div className={ `bottom-nav-wrapper no-nav ${ className }` }>
            <iframe key={ key } ref={ ref } title="Bottom Nav Wrapper" src={ src } />
        </div>
    );
}